import { Observable, Subject } from 'rxjs/Rx';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.scss']
})
export class LeadsComponent implements OnInit {
  @ViewChild('orgName') inputEl: ElementRef;
  @ViewChild('orgAddress') inputEl2: ElementRef;
  @ViewChild('orgPhone') inputEl3: ElementRef;
  @ViewChild('advanceTxt') inputEl4: ElementRef;
  @ViewChild('orgRecord') inputEl5: ElementRef;
  edited = true;
  editedAdd = true;
  editedPhn = true;
  log: string;
  inactive = true;
  inactiveAdd = true;
  inactivePhone = true;
  tooltipPos = 'bottom';
  startdateValue: Date;
  enddateValue: Date;
  highlight = 'unset';
  viewAs: string = 'User';
  orgTypeFilters: string = "";
  txtStatus= '#BABABA';
  txtOrgType= '#BABABA';
  txtAppl= '#BABABA';
  txtRecord= '#BABABA';
  txtAdvance= '#BABABA';
  txtViewas= '#BABABA';
  placeholder = 'Org. Name';
  placeholderAdd = 'Address';
  placeholderPhone = 'Phone';
  placeholderRecord = 'Record Manager';
  toggleMenu= 'none';
  leads: any[];
  constructor() { }

  ngOnInit() {
    this.leads = [
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner',organization: 'Permittee Organization 01', Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton', business_name: 'Dylan Floyd', business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ', phone2:'245-292-5259', potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01 ',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton', business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton', business_name: 'Dylan Floyd',business_name2: 'Violet Shelton',per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01 ',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton', business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01 ',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton',business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton',business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01 ',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton',business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton',business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton',business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953', phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''},
      {address: '37275 St  Rt 17m M, Middle Island, NY, 11953',orgper:'Permittee',orgown:'Owner', organization: 'Permittee Organization 01',Owner_Organization :'Owner Organization 01', contact: 'Dylan Floyd',contact2: 'Violet Shelton',business_name: 'Dylan Floyd',business_name2: 'Violet Shelton', per_own_address: '74 S Westgate St, Albany, NY, 12204',per_own_address2: '37275 St  Rt 17m M, Middle Island, NY, 11953',phone:'371-194-4181 ',phone2:'245-292-5259',potential: ''}
    ];
  }

  search() {
    this.placeholder = 'Search by Org. name';
    this.edited = false;
    // this.inputEl.nativeElement.focus();
  }

  setPlace() {
    this.placeholder = 'Org. Name';

    this.edited = true;
    this.inactive = true;
  }

  searchAdd() {
    this.placeholderAdd = 'Search by Address';
    this.editedAdd = false;
    this.inputEl2.nativeElement.focus();
   
  }


  setAddPlace() {
    this.placeholderAdd = 'Address';
    this.editedAdd = true;
  }

  searchPhone() {
    this.placeholderPhone = 'Search by Phone';
    this.editedPhn = false;
    this.inputEl3.nativeElement.focus();
  }

  setPhonePlace() {
    this.placeholderPhone = 'Phone';
    this.editedPhn = true;
  }

  advanceSearch() {
    this.inputEl4.nativeElement.focus();
  }

  setRecord() {
    this.placeholderRecord = 'Record Manager';
  }
  searchRecord() {
    this.placeholderRecord = 'Search by Record';
    this.inputEl5.nativeElement.focus();
  }

  onToggle() {
    if (this.toggleMenu === 'block') {
      this.toggleMenu = 'none';
    } else {
      this.toggleMenu = 'block';
    }
  }

  // change select text color
  changetxtStatus(status) {
    this.txtStatus = '#000000';
   
  }

  changetxtOrgType() {
    this.txtOrgType = '#000000';
  }

  changetxtAppl() {
    this.txtAppl = '#000000';
  }

  changetxtRecord() {
    this.txtRecord = '#000000';
  }

  setPlaceholderPosition(index) {
    const last = [this.leads.length - 1];
    //
    if (last[0] === index) {
      this.tooltipPos = 'top';
    } else {
      this.tooltipPos = 'bottom';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/leads/leads.component.ts